import {TextField} from "formik-material-ui";
import React from "react";

export const Input = ({...props}) => <TextField fullWidth {...props}/>;
